module.exports = __webpack_public_path__ + "static/img/2.fa497e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v15_new_features/2.png
// module id = hTW5
// module chunks = 0